// extracted by mini-css-extract-plugin
module.exports = {"senceForm":"Sence_senceForm__2Gs52","hidden":"Sence_hidden__JiFVR","switch":"Sence_switch___GzUW"};